import {
  FilterFieldDataType,
  FilterFieldEditorType,
} from '@warebee/shared/common';
import { OrderStatsDataColumn } from '@warebee/shared/dataset-queries';
import { TFunction } from 'i18next';
import { FilterFieldConfig } from '../../common/types';
import { Formatter } from '../../common/useFormatter';
import i18n from '../../i18n';

export function getItemStatsFilterConfigDefault(
  t: TFunction<'app'> = i18n.t,
  formatter?: Formatter,
): FilterFieldConfig<OrderStatsDataColumn>[] {
  return [
    {
      type: 'categoryABC',
      title: t(`Category ABC`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'cumulativePercentRank',
      title: t(`Order Line (ABC %)`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.ABCRange,
      dataType: FilterFieldDataType.NumberRange,
      format: formatter?.formatShare,
      rangeMinValue: 0,
      rangeMaxValue: 1,
      isStatic: true,
      nullOptionTitle: t(`Dead stock`, { ns: 'simulation' }),
    },
    {
      type: 'orderLineCount',
      title: t(`Order Line Count`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
    },
    {
      type: 'quantityOrdered',
      title: t(`Ordered Base UOM qty`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
    },
    {
      type: 'maxWeeklyLinesCount',
      title: t(`Weekly Count (Max.)`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
    },
    {
      type: 'minWeeklyLinesCount',
      title: t(`Weekly Count (Min.)`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
    },
    {
      type: 'avgWeeklyLinesCount',
      title: t(`Weekly Count (Avg.)`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
    },
    {
      type: 'maxDailyLinesCount',
      title: t(`Daily Pick Count (Max.)`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
    },
    {
      type: 'minDailyLinesCount',
      title: t(`Daily Pick Count (Min.)`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
    },
    {
      type: 'avgDailyLinesCount',
      title: t(`Daily Pick Count (Avg.)`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
    },
    {
      type: 'totalDaysOrdered',
      title: t(`Total Days Ordered`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
    },
    {
      type: 'totalWeeksOrdered',
      title: t(`Total Weeks Ordered`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
    },
  ];
}
